<template>
    <v-container>

        <reporting-home v-if="isReportingUser" />
        <default-home v-else />

    </v-container>
</template>

<script>
import DefaultHome from '../components/home/DefaultHome.vue'
import ReportingHome from '../components/home/ReportingHome.vue';

export default {
    components: { DefaultHome, ReportingHome },
}
</script>

<style scoped></style>
